<template>
  <v-container style="width: 100%; padding-bottom: 200px;">
    <v-layout justify-space-between>
      <h1>Edit Groups</h1>
    </v-layout>
    <v-layout justify-center py-3 row wrap>
      <v-card>
      <v-flex xs12 md10 xl8 py-3 >
          <DriverGroupForm  @create="update" :editMode="true" v-if="driverGroup != null" :driverGroup="driverGroup"/>
      </v-flex>
    </v-card>
      <v-flex xs12 md10 xl8 py-3>
        <h4>Driver Group Members</h4>
      </v-flex>
      <v-flex xs12 md10 xl8 py-3>
         
      <v-card><v-flex pb-3> <DriverGroupDrivers v-if="driverGroup != null" :driverGroup="driverGroup"/></v-flex>
      </v-card>
      </v-flex>
      <v-flex xs12 md10 xl8 py-3>
        <h4>Drivers in this group can only be assigned to the users below (if blank, they can be assigned to any user)</h4>
      </v-flex>
      
      <v-flex xs12 md10 xl8 py-3><v-card>
        <v-flex pb-3><DriverGroupUsers v-if="driverGroup != null" :driverGroup="driverGroup"/></v-flex>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import DriverGroupForm from "@/components/settings/general/driver/DriverGroupForm.vue";

import DriverGroupDrivers from "@/components/settings/general/driver/DriverGroupDrivers.vue";
import DriverGroupUsers from "@/components/settings/general/driver/DriverGroupUsers.vue";
import SimpleCard from "@/components/widget/SimpleCard.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "operating_regions",
  components: {
    DriverGroupDrivers,
    DriverGroupForm,
    DriverGroupUsers
  },
  data: function() {
    return {
      driverGroup: null
    };
  },
  mounted: function() {
    setTimeout(this.fetch, 300);
  },
  methods: {
    fetch: async function() {
      try {
        var url = `${this.$store.state.apiUrl}/driver_group/get/${this.$route.params.id}`;

        let response = await axios.get(url, {
          params: {}
        });

        this.driverGroup = response.data;
      } catch (e) {
        console.log(e);
      }
    },
    update: async function() {
      try {
        var url = `${this.$store.state.apiUrl}/driver_group/${this.driverGroup.id}/update`;

        var dg = JSON.parse(JSON.stringify(this.driverGroup));
        dg.driverGroupDrivers = null;
        dg.driverGroupConstrainToUsers = null;

        let response = await axios.post(url, dg);

        this.driverGroups = response.data;
      } catch {
        console.log(e);
      }
    }
  }
};
</script>
